export default __webpack_public_path__ + "media/presence.973b8ba4.png";